import "./DataProtection.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicy from "./sections/PrivacyPolicy";
import WasIstQiGong from "./sections/WasIstQiGong";
import AdditionalLegalLinks from "./sections/AdditionalLegalLinks";
import Footer from "@/reusable_sections/Footer";
export default function DataProtectionPage() {
  return <div>
      <Header />
      <PrivacyPolicy />
      <WasIstQiGong />
      <AdditionalLegalLinks />
      <Footer />
    </div>;
}